import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { FriendsSpaceMessagesEmpty } from './FriendsSpaceMessagesEmpty/FriendsSpaceMessagesEmpty';
import { useMessagesEmptyPresenter } from './MessagesEmpty.presenter';
import { SavedMessagesEmpty } from './SavedMessagesEmpty/SavedMessagesEmpty';
import { ScheduledMessagesEmpty } from './ScheduledMessagesEmpty/ScheduledMessagesEmpty';
import { SecretChatMessagesEmpty } from './SecretChatMessagesEmpty/SecretChatMessagesEmpty';
import { ThreadEmpty } from './ThreadEmpty/ThreadEmpty';

export const MessagesEmpty: FC = observer(() => {
  const presenter = useMessagesEmptyPresenter();

  if (presenter.isShowSavedMessagesEmpty) {
    return <SavedMessagesEmpty />;
  }

  if (presenter.isShowScheduleEmpty) {
    return <ScheduledMessagesEmpty />;
  }

  if (presenter.isShowThreadEmpty) {
    return <ThreadEmpty />;
  }

  if (presenter.isShowFriendsSpaceEmpty) {
    return <FriendsSpaceMessagesEmpty avatarUrl={presenter.group?.avatarUrl || ''} />;
  }

  if (presenter.isSecretChatShowMessagesEmpty) {
    return <SecretChatMessagesEmpty />;
  }

  return null;
});
